import { Record } from 'immutable';
import { UserType } from '../types';
import { KYC_STATUS_FOR_USER_TEXTS, KYC_TYPE_TEXTS } from '../consts';

export type ApiKyc = {
  id: number;
  user_id: number;
  user_type: UserType;
  birth_date: string;
  kyc_type: string;
  status: string;
  first_name: string;
  last_name: string;
  code: string;
  meta_json_front: string;
  meta_json_back: string;
  is_doc_img_file_front_present: boolean;
  is_doc_img_file_back_present: boolean;
  doc_img_file_front_url: string;
  doc_img_file_back_url: string;
  updated_at: string;
  comments: string;
};

const KycBase = Record({
  id: 0,
  userId: 0,
  userType: '' as UserType,
  birthDate: '',
  kycType: '',
  status: '',
  firstName: '',
  lastName: '',
  code: '',
  metaJsonFront: '',
  metaJsonBack: '',
  isDocImgFileFrontPresent: false,
  isDocImgFileBackPresent: false,
  docImgFileFrontUrl: '',
  docImgFileBackUrl: '',
  updatedAt: '',
  comments: '',
});

export class Kyc extends KycBase {
  constructor(apiKyc?: ApiKyc) {
    super({
      id: apiKyc?.id,
      userId: apiKyc?.user_id,
      userType: apiKyc?.user_type,
      birthDate: apiKyc?.birth_date,
      kycType: apiKyc?.kyc_type || 'DRIVER_LICENSE',
      status: apiKyc?.status || 'DRAFT',
      firstName: apiKyc?.first_name,
      lastName: apiKyc?.last_name,
      code: apiKyc?.code,
      metaJsonFront: apiKyc?.meta_json_front,
      metaJsonBack: apiKyc?.meta_json_back,
      isDocImgFileFrontPresent: apiKyc?.is_doc_img_file_front_present,
      isDocImgFileBackPresent: apiKyc?.is_doc_img_file_back_present,
      docImgFileFrontUrl: apiKyc?.doc_img_file_front_url,
      docImgFileBackUrl: apiKyc?.doc_img_file_back_url,
      updatedAt: apiKyc?.updated_at,
      comments: apiKyc?.comments,
    });
  }

  get statusForUserText(): string {
    return KYC_STATUS_FOR_USER_TEXTS[this.status];
  }

  readonly kycTypeText: string = KYC_TYPE_TEXTS[this.kycType];
}
